import { useEffect, useState } from "react";
import { useApi } from "../../hooks/useApi";
import { Usuario } from "../../types/Usuario";
import { AuthContext } from "./AuthContext";
import { setCookie, parseCookies, destroyCookie } from 'nookies'
import Router from "next/router";
import { MercadoPago } from "../../types/MercadoPago";

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
    const [loading, setLoading] = useState(false);
    const [usuario, setUsuario] = useState<Usuario | null>(null);
    const [mercadoPago, setMercadoPago] = useState<MercadoPago | null>(null);
    const api = useApi();

    useEffect(() => {
        validarToken();
    }, []);

    const validarToken = async () => {
        setLoading(true);
        const { 'rifaAuthToken': token } = parseCookies();
        if (token) {
            const resposta = await api.validarToken();
            if (resposta.usuario) {
                setUsuario(resposta.usuario);
                setMercadoPago(resposta.mercadoPago);
            } else {
                removeToken();
                Router.push('/login')
            }
            setLoading(false)
        }
    }


    const login = async (email: string, senha: string) => {
        const data = await api.login(email, senha);

        if (data.erro !== '') {
            return { requires2FA: false, erro: data.erro };
        }

        // Check if 2FA is required
        if (data.requires_2fa) {
            // We don't set any auth token yet
            // Return a special value to indicate 2FA is needed
            return { requires2FA: true, email: data.email };
        }

        if (data.usuario && data.token) {
            api.autorizaToken(data.token);
            setUsuario(data.usuario);
            setMercadoPago(data.mercadoPago);
            setToken(data.token);
            return true;
        }

        return false;
    }

    const verifyTwoFactor = async (email: string, code: string) => {
        const resposta = await api.verifyTwoFactor(email, code);

        if (resposta.erro !== '') {
            return { success: false, error: resposta.erro };
        }

        // 2FA verified successfully
        if (resposta.token) {
            api.autorizaToken(resposta.token);
            setUsuario(resposta.usuario);
            setMercadoPago(resposta.mercadoPago);
            setToken(resposta.token);
            return { success: true, error: '' };
        }

         return { success: false, error: 'Falha na autenticação' };
    };

    const resendTwoFactorCode = async (email: string) => {
        const resposta = await api.resendTwoFactorCode(email);
        return resposta;
    };

    const cadastro = async (data: object) => {
        const resposta = await api.cadastro(data);

        if (resposta.usuario && resposta.token) {
            api.autorizaToken(resposta.token);
            setUsuario(resposta.usuario);
            setMercadoPago(resposta.mercadoPago);
            setToken(resposta.token);
            return resposta;
        }
        return resposta;
    }

    const logout = async () => {
        const resposta = await api.logout();
        if (resposta.erro == '') {
            removeToken();
            setUsuario(null);
            setMercadoPago(null);
            Router.push('/login')
        }
    }

    const removeToken = () => {
        destroyCookie(null, 'rifaAuthToken', {
            domain: process.env.NEXT_PUBLIC_DOMAIN,
            path: "/"
        })
    }

    const setToken = (token: string) => {
        setCookie(undefined, 'rifaAuthToken', token, {
            domain: process.env.NEXT_PUBLIC_DOMAIN,
            maxAge: 30 * 24 * 60 * 60,
            path: "/"
        })
    }

    const atualizaUsuario = (resposta: Usuario) => {
        setUsuario(resposta);
    }
    const atualizarMercadoPago = (resposta: MercadoPago) => {
        setMercadoPago(resposta);
    }

    return (
        <AuthContext.Provider
            value={{
                usuario,
                mercadoPago,
                login,
                verifyTwoFactor,
                resendTwoFactorCode,
                logout,
                cadastro,
                atualizaUsuario,
                atualizarMercadoPago,
                loading
            }}>
            {children}
        </AuthContext.Provider>

    );
}